import { useGasFee } from '@ui/hooks/useGasFee';
import { useEstimateAddMarginGasLimit } from '@ui/services/contract/hooks/TradingPortalFacet/useEstimateAddMarginGasLimit';
import { Position } from '@ui/services/contract/hooks/TradingReaderFacet/useGetPositionV2/types';
import { isNil } from 'lodash-es';

import { useDepositCollateralInput } from './useDepositCollateralInput';

export const useDepositCollateralGasFee = (position: Position) => {
  const amount = useDepositCollateralInput((v) => v.input.value.token);
  const { data: gasLimit } = useEstimateAddMarginGasLimit({
    amount: amount,
    payToken: position.collateralToken,
    positionHash: position.id,
    opts: {
      enabled: !isNil(amount),
    },
  });

  return useGasFee(gasLimit);
};
